import { LINE_HEIGHT_UNITS } from "../../constants";
import { createNumberInputGuards } from "../../helpers/numberInput";

const { sanitise, toCssNumber } = createNumberInputGuards({ allowNegative: false });

const readCurrent = editor => {
  const styled = editor.dom.getParent(editor.selection.getNode(), node => node.style && node.style.lineHeight);
  const parsed = styled ? /^(\d*\.?\d+)(px|%)?$/.exec(styled.style.lineHeight) : null;

  if (!parsed) {
    return { height: "", unit: "" };
  }

  return { height: parsed[1], unit: parsed[2] || "" };
};

const openLineHeightDialog = editor => {
  editor.windowManager.open({
    title: "Line height",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "height",
          label: "Height",
        },
        {
          type: "listbox",
          name: "unit",
          label: "Unit",
          items: LINE_HEIGHT_UNITS,
        },
      ],
    },
    initialData: readCurrent(editor),
    buttons: [
      {
        type: "custom",
        name: "removeButton",
        text: "Remove",
        align: "start",
      },
      {
        type: "cancel",
        name: "closeButton",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submitButton",
        text: "Apply",
        primary: true,
      },
    ],
    onChange: function (api) {
      const { height } = api.getData();
      const sanitised = sanitise(height);

      if (sanitised !== height) {
        api.setData({ height: sanitised });
      }
    },
    onAction: function (api, details) {
      if (details.name === "removeButton") {
        editor.formatter.remove("lineheight");
        api.close();
      }
    },
    onSubmit: function (api) {
      const { height, unit } = api.getData();
      // Re-validated here because pasting bypasses the per-keystroke filter
      const value = toCssNumber(height);

      if (value === "") {
        editor.formatter.remove("lineheight");
      } else {
        editor.execCommand("LineHeight", false, `${value}${unit}`);
      }

      api.close();
    },
  });
};

export { openLineHeightDialog };
